import { useApiGet } from "@/hooks/useApi";
import { getCourse } from "../api";

export function useGetCourse({ courseSlug }) {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: ["courses", courseSlug],
		fn: () => getCourse({ courseSlug }),
		// /courses/:slug/ doubles as the entry-unit lookup and 403s for anonymous
		// visitors on courses whose first unit isn't a free preview. The default
		// handler reads that 403 as "not subscribed" and bounces to /plans before
		// the page renders — while the crawler gets the full prerendered landing
		// page. Course.jsx renders the landing page from /units/ instead, so the
		// failure must stay silent here.
		suppressErrorRedirect: true,
	});

	return { data, isPending, isSuccess, isError, error };
}
